import moment from 'moment';
import 'moment/locale/es';
import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Container, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { matriculadoColumns } from './matriculadosColumns';
import MatriculadosTableWrapper from './MatriculadosTableWrapper';
import { MatriculadosActions } from './MatriculadosActions';
import { useSelector } from 'react-redux';
import {
  setPropsLimit,
  setSearchProp,
  setPage,
  setFiltersAndSort
} from 'redux/matriculadosSlice';
import { useDispatch } from 'react-redux';
import { getMatriculados } from 'redux/matriculadosSlice';
import Select from 'react-select';
moment.locale('es');

const ListaMatriculados = ({ switchNewUser, setSwitchNewUser }) => {
  //UseStates
  const [filterUsers, setFilterUsers] = useState('all');
  const [searchUser, setSearchUser] = useState('');
  const [dateFrom, setDateFrom] = useState(''); // 'YYYY-MM-DD'
  const [dateTo, setDateTo] = useState(''); // 'YYYY-MM-DD'
  const [cleanList, setCleanList] = useState([]);
  const [data, setData] = useState([]);
  const page = useSelector(state => state.matriculados.page);
  const propsLimit = useSelector(state => state.matriculados.propsLimit);
  const filtersAndSort = useSelector(
    state => state.matriculados.filtersAndSort
  );
  const searchProp = useSelector(state => state.matriculados.searchProp);
  const matriculados = useSelector(state => state.matriculados.data);
  const dispatch = useDispatch();

  const options = [
    { value: 'all', label: 'Todos' },
    { value: 'true', label: 'Con login directo' },
    { value: 'false', label: 'Sin login directo' }
  ];

  const buildNextFilters = (overrides = {}) => {
    const next = {
      ...filtersAndSort,
      ...overrides
    };

    // mapear select de bypassed (string) a boolean o quitarlo
    if (filterUsers === 'true') next.bypassed = true;
    else if (filterUsers === 'false') next.bypassed = false;
    else delete next.bypassed;

    // incluir fechas sólo si están cargadas
    if (dateFrom) next.dateFrom = dateFrom;
    else delete next.dateFrom;
    if (dateTo) next.dateTo = dateTo;
    else delete next.dateTo;

    return next;
  };
  const handleChange = selectedOption => {
    const value = selectedOption.value;
    setFilterUsers(value);

    // reconstruyo filtros con el nuevo bypassed
    const next = buildNextFilters();
    dispatch(setFiltersAndSort(next));
    dispatch(getMatriculados(next, page, propsLimit, searchProp));
  };

  const handleSelect = () => {
    let users = matriculados.length > 0 ? matriculados : cleanList;
    // Filtro local sólo por bypassed (el resto lo hace el backend)
    if (filterUsers !== 'all') {
      users = users.filter(
        u => String(u.bypassed) === String(filterUsers === 'true')
      );
    }
    return users;
  };

  useEffect(() => {
    setCleanList(matriculados);
  }, [matriculados]);

  useEffect(() => {
    matriculados.length && setCleanList(handleSelect);
  }, [matriculados, page, propsLimit, filtersAndSort, searchProp, filterUsers]);

  useEffect(() => {
    setData(
      cleanList?.map(user => {
        return {
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          dni: user.dni,
          matricula: user.matricula,
          bypassed: user.bypassed ? 'Sí' : 'No',
          created_at: user.created_at,
          actions: (
            <MatriculadosActions
              matriculados={user}
              switchNewUser={switchNewUser}
              setSwitchNewUser={setSwitchNewUser}
            />
          )
        };
      })
    );
  }, [cleanList, propsLimit]);

  return (
    <Container fluid>
      <Row className="mb-5">
        <Col lg={3} sm={12}>
          <Form.Group className="mb-3" controlId="formFilterByDirectLogin">
            <Form.Label style={{ minWidth: '200px' }}>
              Filtrar por login directo:
            </Form.Label>
            <Select
              value={options.find(option => option.value === filterUsers)}
              onChange={handleChange}
              options={options}
              isSearchable={false}
            />
          </Form.Group>
        </Col>

        <Col lg={3} sm={12}>
          <Form.Group className="mb-3" controlId="formSearchUser">
            {' '}
            {/* Modificado aquí */}
            <Form.Label>Buscar usuario</Form.Label>
            <Form.Control
              type="text"
              size="md"
              placeholder="Ingrese dato del usuario"
              value={searchUser}
              onChange={e => setSearchUser(e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col lg={2} sm={12}>
          <Form.Group className="mb-3" controlId="formSearchUser">
            <Form.Label>Fecha desde</Form.Label>
            <Form.Control
              type="date"
              size="md"
              value={dateFrom}
              onChange={e => setDateFrom(e.target.value)}
              placeholder="Desde"
              title="Fecha desde"
              style={{ minWidth: 150 }}
            />
          </Form.Group>
        </Col>
        <Col lg={2} sm={12}>
          <Form.Group controlId="formSearchUser">
            <Form.Label>Fecha Hasta</Form.Label>
            <Form.Control
              type="date"
              size="md"
              value={dateTo}
              onChange={e => setDateTo(e.target.value)}
              placeholder="Hasta"
              title="Fecha hasta"
              style={{ minWidth: 150 }}
            />
          </Form.Group>
        </Col>

        <Col lg={2} sm={12}>
          <div
            className="d-flex flex-column flex-sm-row gap-2 w-100 w-sm-50 w-lg-100"
            style={{ marginTop: '34px' }}
          >
            {/* Modificado aquí */}
            <Button
              className="w-100 w-sm-auto"
              size="sm"
              onClick={() => {
                dispatch(setSearchProp(searchUser));
                const next = buildNextFilters();
                dispatch(setFiltersAndSort(next));
                dispatch(getMatriculados(next, page, propsLimit, searchUser));
              }}
            >
              Buscar
            </Button>
            <Button
              className="w-100 w-sm-auto"
              size="sm"
              variant="secondary"
              onClick={() => {
                // reset de todo
                setFilterUsers('all');
                setSearchUser('');
                setDateFrom('');
                setDateTo('');
                dispatch(setSearchProp(''));
                dispatch(setPropsLimit(10));
                dispatch(setPage(0));
                dispatch(setFiltersAndSort({}));
                dispatch(getMatriculados({}, 0, 10, ''));
              }}
            >
              Limpiar
            </Button>
          </div>
        </Col>
      </Row>
      {data && matriculadoColumns && (
        <MatriculadosTableWrapper columns={matriculadoColumns} data={data} />
      )}
    </Container>
  );
};

ListaMatriculados.propTypes = {
  switchNewUser: PropTypes.bool.isRequired,
  setSwitchNewUser: PropTypes.func.isRequired
};

export default ListaMatriculados;
